import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Image } from "@chakra-ui/react";
import { useState, useRef, useEffect } from "react";
import { keyframes } from "@emotion/react";
import { IMG_URL } from "../common/Constant";
// Music wave animation keyframes
const waveAnimation = keyframes `
  0%, 100% {
    transform: scaleY(0.5);
    opacity: 0.8;
  }
  50% {
    transform: scaleY(1);
    opacity: 1;
  }
`;
export default function EventPoster({ eventPoster, headerVideo, isDateView = false, }) {
    const [isMuted, setIsMuted] = useState(true);
    const videoRef = useRef(null);
    const toggleMute = () => {
        if (videoRef.current) {
            const newMutedState = !isMuted;
            videoRef.current.muted = newMutedState;
            videoRef.current.volume = newMutedState ? 0 : 1;
            setIsMuted(newMutedState);
            // Ensure video plays when unmuted
            if (!newMutedState && videoRef.current.paused) {
                videoRef.current.play().catch(() => {
                    // Auto-play might be blocked, that's okay
                });
            }
        }
    };
    // Sync video muted state with component state
    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.muted = isMuted;
            videoRef.current.volume = isMuted ? 0 : 1;
        }
    }, [isMuted]);
    return (_jsxs(Box, { width: "100%", h: "100%", display: "flex", position: "relative", p: 0, children: [_jsx(Box, { width: "100%", height: "100%", cursor: "pointer", onClick: toggleMute, position: "relative", children: _jsx("video", { ref: videoRef, style: { width: "100%", height: "100%", objectFit: "cover" }, poster: `${IMG_URL}/background/event_page_bg.png`, autoPlay: true, loop: true, muted: isMuted, playsInline: true, children: _jsx("source", { src: headerVideo && headerVideo.trim() !== ""
                            ? headerVideo
                            : "/videos/event_page_bg.mp4?ngsw-bypass=true", type: "video/mp4" }) }) }), _jsx(Box, { position: "absolute", top: "1px", left: "0", width: "100%", height: "100%", bg: "linear-gradient(180.48deg, rgba(0, 0, 0, 0) 0.45%, #111111 99.62%)", pointerEvents: "none" }), _jsx(Box, { position: "absolute", top: isDateView ? 8 : 4, left: "50%", transform: "translateX(-50%)", zIndex: 10, cursor: "pointer", onClick: (e) => {
                    e.stopPropagation();
                    toggleMute();
                }, display: "flex", alignItems: "center", justifyContent: "center", gap: 1, bg: "whiteAlpha.300", backdropFilter: "blur(8px)", borderRadius: "full", px: 3, py: 2, _hover: { bg: "rgba(0, 0, 0, 0.3)" }, transition: "all 0.2s ease", children: [0, 1, 2, 3].map((index) => {
                    // Different heights for each bar to show music is playing (both muted and unmuted)
                    const mutedHeights = [7, 9, 6, 8];
                    const unmutedHeights = [10, 12, 8, 11];
                    const heights = isMuted ? mutedHeights : unmutedHeights;
                    return (_jsx(Box, { width: "2px", height: `${heights[index]}px`, bg: isMuted
                            ? "rgba(255, 255, 255, 0.5)"
                            : "rgba(255, 255, 255, 0.7)", borderRadius: "full", animation: `${waveAnimation} 1.2s ease-in-out infinite`, style: {
                            animationDelay: `${index * 0.12}s`,
                            transformOrigin: "center bottom",
                        } }, index));
                }) }), eventPoster && (_jsx(Box, { position: "absolute", w: "100%", minW: "250px", minH: "250px", maxW: "250px", maxH: "450px", left: "50%", bottom: "10px", transform: "translateX(-50%)", overflow: "hidden", children: _jsx(Image, { src: eventPoster, borderRadius: "lg", width: "100%", height: "100%", objectFit: "cover" }) }))] }));
}
